import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { mobileOnly: Boolean }

  blurOnEnter(event) {
    if (event.key != "Enter") { return }
    if (this.#mobileOnly() && !this.#mobilePhone()) { return }

    event.currentTarget.blur()
  }

  #mobileOnly() { return this.mobileOnlyValue }

  #mobilePhone() {
    const userAgent = window.navigator.userAgent.toLowerCase()
    return /(?:android|iphone)/.test(userAgent);
  }
}
